<template>
  <zm-dialog :visible.sync="visible" class="opc-partner-offer-dialog" show-close width="890px" @close="handleCancel">
    <div ref="offerDetailTemplateRef" class="opc-partner-offer-dialog__content" v-html="offerDetailTemplate" />
  </zm-dialog>
</template>

<script>
import _ from 'lodash';
import offerDetailBg from '@/assets/partner/offer-detail-bg.svg';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import { getMessageTemplateByRules } from '@/views/config/partner-refer/helper/validator';
import {
  getPartnerImageFileInfo,
  getPartnerRefer,
  replaceOfferDetailWithImageLink,
} from '@/views/config/partner-refer/helper/utils';
import archiveVersionMixin from '@/views/config/partner-refer/dialog/archive-version';

export default {
  name: 'PartnerOfferDetail',
  mixins: [ConfirmComponent, archiveVersionMixin],
  data() {
    const offerDetailMsg = getPartnerRefer().offerDetailMsg;

    return {
      offerDetailBg,
      offerDetailTemplate: _.isArray(offerDetailMsg) ? '' : offerDetailMsg,
    };
  },
  computed: {
    ...mapGetters(['isEligibleForPartner', 'getSelectedPlans', 'partnerRefer', 'showInEligibleMsg', 'partnerReferProductNames', 'getSelectedPlansWithQuantityMap']),
  },
  methods: {
    replaceOfferDetailWithLogo(content = '') {
      return replaceOfferDetailWithImageLink(content, /\${offerDetailLogo}/g, getPartnerImageFileInfo()?.offerDetailLogo);
    },
    changeOfferDetailTemplate(content) {
      this.offerDetailTemplate = this.replaceOfferDetailWithLogo(content);
    },
    getOfferDetailTemplateByRules() { // new template for type(Array)
      const { offerDetailHeader, offerDetailMsg, offerDetailFooter } = this.partnerRefer || {};

      const header = getMessageTemplateByRules(offerDetailHeader)?.messageBody || "";
      const body = getMessageTemplateByRules(offerDetailMsg)?.messageBody || "";
      const footer = getMessageTemplateByRules(offerDetailFooter)?.messageBody || "";

      this.changeOfferDetailTemplate(`${header}${body}${footer}`);
    },
    updateOfferDetailMsg() {
      const offerDetailMsg = this.partnerRefer?.offerDetailMsg || [];

      if (_.isArray(offerDetailMsg)) {
        this.getOfferDetailTemplateByRules();
      } else {
        /// todo will archive
        this.replaceOfferDetailMsg(); // need config several rule into tag attribute
        this.showAllPromotionPlans();
      }
    },
  },
  watch: {
    visible: {
      handler(val) {
        const promoPartnerName = `partner promo - ${this.partnerRefer.partnerName}`;

        if (val) {
          this.$nextTick(() => this.updateOfferDetailMsg());
        }

        val ? this.$tracking.buyInteraction(
          promoPartnerName,
          `${this.partnerReferProductNames} - offer details modal - impression`,
        ) : this.$tracking.buyInteraction(
          promoPartnerName,
          `${this.partnerReferProductNames} - offer details modal - exit`,
        );
      },
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.is-keyboard-event .opc-partner-offer-dialog .zm-dialog__headerbtn:focus {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #0e72ed;
}

.opc-partner-offer-dialog {
  .zm-dialog {
    @include media(mobile) {
      padding: 24px 16px !important;
    }

    &__headerbtn {
      top: 15px;
      right: 13px;
      font-size: 20px;

      .zm-dialog__close {
        color: #131619 !important;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__title {
    font-family: $happy-display;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    color: #3B3C69;
    margin-bottom: 25px;

    @include media(mobile) {
      margin-bottom: 12px;
    }
  }

  &__img {
    width: 249px;
    height: 138px;
    margin-bottom: 50px;

    @include media(mobile) {
      width: 200px;
    }
  }

  &__content {
    margin: 0px auto;
    text-align: center;

    &--title {
      text-align: center;
      line-height: 36px;
      font-size: 24px;
      color: #00053D;
      font-family: 'Internacional', 'Helvetica', 'Arial';
      font-weight: 400;
      padding: 0px 60px;
    }

    &--subTitle {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      margin-top: 12px;
      font-style: normal;
      padding: 0px 60px;
    }

    &--desc {
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      line-height: 18px;
      padding: 0px 50px;
    }

    @include media(mobile) {
      &--title {
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
      }

      &--subtitle {
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
      }

      &--desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
      }

      &--title, &--subTitle, &--desc {
        padding: 0px;
      }
    }
  }
}
</style>
